import Axios from "axios";

export default {
  get(licensePlate) {
    return Axios.get(
      "/vehicle/get?licensePlate=" + licensePlate
    );
  },

};